import { EventRFeature } from "@eventr/common";
import { useHasFeature } from "../hooks/useHasFeature";

interface IFeatureHideProps {
  children?: React.ReactNode;
  requiredFeature?: EventRFeature;
}

export const FeatureHide = ({ children, requiredFeature }: IFeatureHideProps) => {
  const hasFeature = useHasFeature(requiredFeature);
  if (requiredFeature && !hasFeature) {
    return null;
  }
  return <>{children}</>;
};
